import Swal from "sweetalert2";
import { userManagement_Update_Roles_Api } from "../../Apis/user/ApiConfig";
import {
  USER_MANAGEMENT_ROLES_UPDATE_ERROR,
  USER_MANAGEMENT_ROLES_UPDATE_REQUEST,
  USER_MANAGEMENT_ROLES_UPDATE_SUCCESS,
} from "../../Types/user/Types";

export const userManagement_Update_roles_Success = (res) => {
  return {
    type: USER_MANAGEMENT_ROLES_UPDATE_SUCCESS,
    payload: res,
  };
};
export const userManagement_Update_roles_Error = (error) => {
  return {
    type: USER_MANAGEMENT_ROLES_UPDATE_ERROR,
    error: error,
  };
};

export const userManagement_Update_roles_Request = (res) => {
  return {
    type: USER_MANAGEMENT_ROLES_UPDATE_REQUEST,
    payload: res,
  };
};

export const userManagement_Update_roles_ActionHandler = (roleData) => {
  return (dispatch) => {
    dispatch(userManagement_Update_roles_Request());
    try {
      userManagement_Update_Roles_Api(roleData)
        .then((res) => {
          if (res) {
            if (res && res?.data && res?.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "Updated Successfully!",
                showConfirmButton: false,
                timer: 1500,
              });
              dispatch(userManagement_Update_roles_Success(res?.data));
            } else {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                confirmButtonColor: "rgb(231,52,70)",
              });
              dispatch(userManagement_Update_roles_Error(res));
            }
          } else {
            dispatch(userManagement_Update_roles_Error(""));
          }
        })
        .catch((err) => {
          dispatch(
            userManagement_Update_roles_Error("Something Went Wrong!!!")
          );
        });
    } catch (err) {
      dispatch(userManagement_Update_roles_Error(err));
    }
  };
};
